import "@emotion/react";

export enum ThemeType {
  DARK = "DARK",
  LIGHT = "LIGHT",
}

export interface UiModuleTheme {
  type: ThemeType;
  secondaryTheme?: UiModuleTheme;
  bodyBackground: string;
  successColor: string;
  sideBarBackground: GreyVariant;
  appBarBackground: GreyVariant;
  skeletonBg: GreyVariant;
  material: {
    primary: GreyVariant;
    secondary: GreyVariant;
    error: GreyVariant;
    background: GreyVariant;
    surface: GreyVariant;
    onPrimary: GreyVariant;
    onSecondary: GreyVariant;
    onSurface: GreyVariant;
    onError: GreyVariant;
    textPrimaryOnBackground: GreyVariant;
    textSecondaryOnBackground: GreyVariant;
    textHintOnBackground: GreyVariant;
    textDisabledOnBackground: GreyVariant;
    textIconOnBackground: GreyVariant;
    textPrimaryOnLight: GreyVariant;
    textSecondaryOnLight: GreyVariant;
    textHintOnLight: GreyVariant;
    textDisabledOnLight: GreyVariant;
    textIconOnLight: GreyVariant;
    textPrimaryOnDark: GreyVariant;
    textSecondaryOnDark: GreyVariant;
    textHintOnDark: GreyVariant;
    textDisabledOnDark: GreyVariant;
    textIconOnDark: GreyVariant;
  };
}

declare module "@emotion/react" {
  export interface Theme extends UiModuleTheme {}
}

type GreyVariant =
  | "rgba(22, 181, 231, 1)"
  | "rgba(34, 169, 212, 1)"
  | "rgba(250, 166, 26, 1)"
  | "rgba(240, 71, 71, 1)"
  | "rgba(0, 0, 0, 0.87)"
  | "rgba(0, 0, 0, 0.54)"
  | "rgba(0, 0, 0, 0.38)"
  | "rgba(28, 28, 36, 1)"
  | "rgba(47, 49, 54, 1)"
  | "rgb(28, 28, 36, 1)"
  | "rgba(5, 5, 6, 1)"
  | "rgba(142, 146, 151, 1)"
  | "rgba(255, 255, 255, 0.5)"
  | "rgba(185, 187, 190, 1)"
  | "rgba(255, 255, 255, 0.7)"
  | "rgba(255,255,255,.87)"
  | "rgba(255, 255, 255, 1)"
  | "rgba(107, 107, 107, 1)"
  | "rgba(191, 191, 191, 1)"
  | "rgba(255, 255, 255, 0.87)"
  | "rgba(195, 195, 195, 1)";
